<template>
  <div class="withdrawal-upload">
    <el-row>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <bUploadImage
          ref="uploadImg"
          test_id="deposit_upload_img"
          @handleRemove="handleRemove"
          @successHandle="successHandle"
          @errHandle="errHandle"
          @progressHandle="progressHandle"
          @uploadHandle="uploadHandle"
        />
      </el-col>
    </el-row>
    <div class="foot-tips-font-style">
      <div class="tip-p">
        {{$t('withdrawal.withdrawalTips.uploadTips.tip2')}}
        <div class="tips-font-style">{{$t('withdrawal.withdrawalTips.uploadTips.tip3')}}</div>
        {{$t('withdrawal.withdrawalTips.uploadTips.tip4')}}
        <br/>
        {{$t('withdrawal.withdrawalTips.uploadTips.tip5')}}
      </div>
      <div class="foot-tips-font-style">{{$t('withdrawal.withdrawalTips.uploadTips.tip6')}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imageKeys: []
    }
  },
  mounted () {
    let _comps = {
      'deposit_upload_img': this.$refs.uploadImg
    }
    window.uploadPic = this.Util.uploadPicBinder(this, _comps)
  },
  methods: {
    handleRemove (index) {
      this.imageKeys.splice(index, 1)
    },
    successHandle () {
      this.disabledSubmit = false
    },
    errHandle () {
      this.disabledSubmit = false
    },
    progressHandle () {
      this.disabledSubmit = true
    },
    uploadHandle (imageKey) {
      // this.imageKeys.push(imageKey)
      // console.log(JSON.stringify(imageKey), 'imageKey')
      this.imageKeys = imageKey
      this.$emit('uploadHandle', this.imageKeys)
    },
    clearImageKeys () {
      this.imageKeys = []
      this.$refs.uploadImg.clearFiles()
    }
  }

}
</script>
<style lang="scss">
.withdrawal-upload{
  .tips-font-style{
    line-height: 16px!important
  }
  .el-upload--picture-card {
    background-color: #fff !important;
    border: 1px dashed #f9c114 !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    width: 60px !important;
    height: 60px !important;
    cursor: pointer;
    line-height: 60px !important;
    vertical-align: top;
  }
  color:rgba(229,141,21,1);
  .el-upload--picture-card i {
    color: #f9c114 !important;
    font-size: 18px !important;
  }
  .tip-p{
    padding: 10px 0 10px 0 !important;
  }
  .tips-font-style{
    font-size:11px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(229,141,21,1);
    line-height:16px;
  }
  .foot-tips-font-style{
    font-size:11px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(125,125,125,1);
    line-height:16px;
  }
}
</style>
